import React, { useState } from 'react';
import { Layout } from 'antd'; // Make sure this is imported
import TopHeader from '../components/Layout/TopHeader';
import SalesManagerSidebar from '../components/Layout/SalesManagerSidebar';
import { Outlet } from 'react-router-dom';

const { Content } = Layout;

const SalesManagerLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => setCollapsed(!collapsed);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Corrected Line: Pass setCollapsed to the sidebar */}
      <SalesManagerSidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      
      <Layout>
        <TopHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
        <Content style={{ margin: '16px', padding: 16, background: '#fff', minHeight: 280 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default SalesManagerLayout;
